export default __webpack_public_path__ + "static/media/nex-jobs-sidebar.d7623a16.png";